import libphonenumber from 'google-libphonenumber';

const PhoneUtility = {
  isValidNumber(phone, country) {
    try {
      let PhoneNumber = libphonenumber.PhoneNumberUtil.getInstance();
      let number = PhoneNumber.parse(phone, country);
      let decision = PhoneNumber.isValidNumber(number) ? true : false;
      return decision;
    } catch (e) {
      return false;
    }
  },
};

export default PhoneUtility;
